var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-apple",on:{"click":function($event){return _vm.loginApple()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }